/**
 * © 2025 Malvys Exaucé Dessou — ZonePro. Tous droits réservés.
 */
import React, { useEffect, useState } from 'react';
import api from '../api';

// Which release answers (docs/specs/version-shown): read from /api/version once per page load, never baked in.
let reading = null;
const readVersion = () => {
  reading = reading ?? api.get('/version')
    .then(({ data }) => `${data.version} · ${data.commit}`)
    .catch(() => { reading = null; return null; });
  return reading;
};

const VersionStamp = ({ className = '', testId }) => {
  const [text, setText] = useState(null);

  useEffect(() => {
    let mounted = true;
    readVersion().then((read) => { if (mounted) setText(read); });
    return () => { mounted = false; };
  }, []);

  if (!text) return null;
  return (
    <span className={`font-mono ${className}`} title="Version du produit" data-testid={testId}>
      {text}
    </span>
  );
};

export default VersionStamp;
